import React from 'react';
import './LockIcon.scss';

interface LockIconProps {
  lockModeEnabled: boolean;
  onToggle: () => void;
  className?: string;
}

const LockIcon: React.FC<LockIconProps> = ({
  lockModeEnabled,
  onToggle,
  className = '',
}) => {
  return (
    <button
      aria-label={lockModeEnabled ? 'Unlock controls' : 'Lock controls'}
      title={lockModeEnabled ? 'Unlock controls' : 'Lock controls'}
      className={`clickable-icon lock-icon ${lockModeEnabled ? 'active' : ''} ${className}`}
      onClick={onToggle}
    >
      <i className={`fa lock-icon__symbol ${lockModeEnabled ? 'fa-lock' : 'fa-lock-open'}`} />
    </button>
  );
};

export default LockIcon;
